import { checkIfCompatibleWithBackend } from "@todesktop/client-util";
import { invoke } from "./invoke.js";
import { createOnAndOffNamespaceListeners, } from "./utils.js";
export async function getAvailableSpellCheckerLanguages() {
    return invoke({
        namespace: "session",
        property: "availableSpellCheckerLanguages",
    });
}
export async function getSpellCheckerEnabled() {
    return invoke({
        namespace: "session",
        property: "spellCheckerEnabled",
    });
}
export async function getDefaultSession() {
    if (checkIfCompatibleWithBackend("session:getDefaultSession", "4.17.0")) {
        return invoke({
            namespace: "session",
            property: "defaultSession",
        });
    }
}
export async function setSpellCheckerEnabled(enable) {
    return invoke({
        namespace: "session",
        method: "setSpellCheckerEnabled",
        args: [enable],
    });
}
export async function setSpellCheckerLanguages(languages) {
    return invoke({
        namespace: "session",
        method: "setSpellCheckerLanguages",
        args: [languages],
    });
}
export async function getSpellCheckerLanguages() {
    return invoke({
        namespace: "session",
        method: "getSpellCheckerLanguages",
        args: [],
    });
}
export async function listWordsInSpellCheckerDictionary() {
    return invoke({
        namespace: "session",
        method: "listWordsInSpellCheckerDictionary",
        args: [],
    });
}
export async function addWordToSpellCheckerDictionary(word) {
    return invoke({
        namespace: "session",
        method: "addWordToSpellCheckerDictionary",
        args: [word],
    });
}
export async function removeWordFromSpellCheckerDictionary(word) {
    return invoke({
        namespace: "session",
        method: "removeWordFromSpellCheckerDictionary",
        args: [word],
    });
}
export async function fromPartition(partition, options) {
    if (checkIfCompatibleWithBackend("session:fromPartition", "4.17.0")) {
        return invoke({
            namespace: "session",
            method: "fromPartition",
            args: [partition, options],
        });
    }
}
export async function setDisplayMediaRequestHandler(ref, handler) {
    if (checkIfCompatibleWithBackend("session:setDisplayMediaRequestHandler", "5.7.0")) {
        return invoke({
            instanceRef: ref,
            namespace: "session",
            method: "setDisplayMediaRequestHandler",
            args: [handler],
        });
    }
}
const listeners = createOnAndOffNamespaceListeners("session", "4.17.0");
export const on = listeners.on;
export const removeAllListeners = listeners.removeAllListeners;
